/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { StudentEvaluationFeedbackRequestReason } from './studentEvaluationFeedbackRequestReason';
import type { StudentEvaluationFeedbackRequestCategory } from './studentEvaluationFeedbackRequestCategory';
import type { StudentEvaluationFeedbackRequestRunId } from './studentEvaluationFeedbackRequestRunId';

/**
 * Request payload for submitting feedback on an evaluation.
 */
export interface StudentEvaluationFeedbackRequest {
  /** Whether the student found the evaluation helpful */
  isHelpful: boolean;
  /** Optional text or structured reason for the feedback */
  reason?: StudentEvaluationFeedbackRequestReason;
  /** Structured not-helpful category when the student chose a preset reason */
  category?: StudentEvaluationFeedbackRequestCategory;
  /** Optional evaluation run id the feedback targets */
  runId?: StudentEvaluationFeedbackRequestRunId;
}
